export { AngularMultiSelect } from './multiselect.component';
export { ClickOutsideDirective } from './clickOutside';
export { ListFilterPipe } from './list-filter';
export { Item } from './menu-item';
export { TemplateRenderer } from './menu-item';
export { AngularMultiSelectModule } from './multiselect.component';
//# sourceMappingURL=angular2-multiselect-dropdown.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-multiselect-dropdown/angular2-multiselect-dropdown.js
// module id = 91
// module chunks = 9